export default {
    cost: {
        orgNameRequired: '请输入机构名称',
        status: '状态',
        search: '搜索',
        accountList: '账户列表',
        orgName: '机构名称',
        billing: '计费方式',
        unlimited: "包年不限量",
        Per: "按次计费",
        Arrears: "已欠费",
        InService: "服务中",
        DueSoon: "即将欠费",
        recharge: "提醒充值",
        manage: '管理',
        sendSuccess: '已成功发送充值提醒',
        all: '全部'
    },
    account: {
        addData: "添加数据",
        hasSelect: "已选",
        classify: "分类",
        dic: "字典",
        english: "英文",
        searchCondition: "搜索条件",
        accountRequired: "请输入登录名",
        orgNameRequired: "请输入机构名称",
        startDate: "开始日期",
        endDate: "结束日期",
        accountList: "账户列表",
        addAccount: "添加账户",
        accountName: "登录名",
        orgName: "机构名称",
        createTime: "开通时间",
        nodeStatus: "节点状态",
        freeze: "冻结",
        cancelFreeze: "解除冻结",
        recover: "恢复",
        manage: "管理",
        to: "至",
        orgNameRequiredSelect: "请选择机构名称",
        uscCode: "组织机构代码",
        userName: "管理员姓名",
        telPhone: "管理员手机号",
        callAddress: "应用回调地址",
        callbackUrl: "前置机调用地址",
        location: "归属地",
        autoComplete: "自动带出",
        userNameRequired: "请输入管理员姓名",
        telPhoneRequired: "请输入管理员电话",
        callAddressRequired: "请输入应用回调地址",
        callbackUrlRequired: "请输入前置机调用地址",
        locationRequired: "请选择归属地",
        keyFile: "导入区块链上链key",
        upload: "点击上传",
        keyFileTip: "只能上传txt文件，且不超过500kb",
        relationsList: "关联机构类型",
        legalPersonNameRequired: "请输入法人姓名",
        fatherOrgIdRequired: "请选择所属上级企业",
        orgTradeTypeRequired: "请选择企业所属行业",
        orgLevelRequired: "请选择账户类型",
        maxLength2To20: "长度在 2 到 20 个字符",
        maxLength2To50: "长度在 2 到 50 个字符",
        retryOrgCode: "请再次组织机构代码",
        orgCodeValid: "组织机构代码为数字字母组合，且长度不大于18位",
        accountEdit: "账户编辑",
        fileTypeValid: "文件类型只能为txt文件",
        fileMaxSize: "上传文件大小不能超过 50MB!",
        resetPassword: "重置密码",
        importAccountInfo: "导出账户信息",
        syncToFrondEnd: "同步至前置机",
        adminTel: "管理员电话",
        importApp: "导入应用",
        addDataModel: "添加数据模型",
        relativeDataModel: "关联数据模型",
        dataModelCode: "数模编号",
        dataModelName: "数模名称",
        desc: "概述",
        exportDeployFile: "导出部署文件",
        fileRequired: "请上传文件",
        fileSelect: "选择文件",
        successToSync: "同步至前置机成功",
        pleaseSelectFile: "请先选择需要上传的文件",
        passwordResetTip: "当前操作会重置密码，请确认是否继续",
        friendlyTip: "友情提示",
        passwordResetSuccess: "密码重置成功，新的密码为:  ",
        passwordResetError: "密码重置失败",
        basicInfo: "基本信息",
        dataModelNameRequired: "请输入数据模型名称",
        dataModelDesc: "数模概述",
        descRquired: "请输入概述",
        appName: "所属应用",
        appNameRequired: "请选择所属应用",
        dataCatalogue: "数据目录",
        data: "数据",
        dataModelNameRequired1: "请输入数模名称",
        dataModelDescRequired: "请输入数模概述",
        appNameValid: "所属应用只能由字母、数字、下划线和汉字组成",
        dataModelDataAndCatalogueRequired: "请添加数据目录和数据",
        saveSuccess: "保存成功",
        keywordRequiredBeforeSearch: "请输入关键字后再搜索",
        appContentRequired: "应用内容未填写完整",
        dataModelNoEmpty: "数据目录/数据不能为空",
        retrievalItemRequired: "请至少添加一个检索项，方便数据查找",
        addDataModelCatalogue: "添加数据目录",
        isSetRetrievalItem: "是否设为检索项",
        type: "类型",
        file: "文件",
        string: "字符串",
        isSetRetrievalItem1: "是否设置为检索项",
        searchCatalogueBykeyword: "根据关键字搜索条目",
        keyword: "关键字",
        keywordRequired: "请输入关键字",
        settingToRetrieval: "设置为检索项",
        selectBusiness: "勾选配置业务行为",
        name: "名称",
        category: "类别",
        companyName: "企业名称",
        applicationName: "应用名称",
        retrievalItem: '检索项',
        personal: "个人",
        company: "企业",
        digitalAnalogIntroduction: "数模介绍",
        editIntroduction: "编辑介绍",
        saveIntroduction: "保存介绍",
        haveES: '是否部署ES'
    },
    certificate: {
        searchCondition: "搜索条件",
        accountRequired: "请输入登录名",
        orgNameRequired: "请输入机构名称",
        certificateList: "证书列表",
        account: "登录名",
        orgName: "机构名称",
        certificateName: "证书名称",
        limitTime: "有效期",
        certificateUpdateSuccess: "证书更新成功"
    },
    companyType: {
        fuzzyTypeNameRequired: "请输入类型名称",
        companyTypeList: "企业类型列表",
        addCompanyType: "添加企业类型",
        typeName: "类型名称",
        desc: "概述",
        relativeCompany: "关联企业",
        deleteCompanyTip: "确定删除该企业类型吗？",
        remark: "类型描述",
        orgRelations: "关联企业",
        orgRelationsRequired: "请选择关联企业",
        typeNameValid: "类型名称只能包含汉字、字母、数字，不支持特殊符号！",
        remarkRequired: "请输入类型描述",
        relativeCompanySuccess: "关联企业成功",
        addCompanySuccess: "添加企业类型成功"
    },
    dataCataLog: {
        orgIdRequired: "请选择归属机构",
        applyIdRequired: "请选择数据模型",
        pleaseInput: "请输入",
        dataCata: "数据目录",
        orgName: "机构名称",
        applyName: "数模名称",
    },
    dataExchange: {
        askforOrgIdRequired: "请选择数据申请方",
        giveOrgIdRequired: "请选择数据提供方",
        selectDate: "选择日期",
        changeLog: "交换记录",
        applyName: "场景",
        askforOrgName: "数据申请方",
        giveOrgName: "数据提供方",
        createdTime: "申请时间",
        look: "查看",
        detailPageTitle: "数据交换全过程上链信息",
        orgName: "机构名称",
        activeName: "行为",
        operateTime: "操作时间",
        address: "存证地址",
        time: "存证时间",
        dataReceive: "数据接收方",
        content: "内容",
        fileName: "文件名称",
        identityInputNum: '存证编号'
    },
    dataModelMall: {
        applyNameRequired: "请输入数模名称",
        orgId: "归属机构",
        dataModelList: "数模列表",
        applyName: "数模名称",
        desc: "概述",
        orgName: "归属机构",
        dataSource: "数据来源",
        frontEnd: "前置机",
        version: "版本",
        download: "可下载",
        onlyPreview: "仅预览",
        dataDetail: "数据详情",
        companyName: "企业名称",
        appName: "应用名称",
        dataCata: "数据目录",
        retrievalItem: "检索项",
        data: "数据",
        basicInfo: "基本信息"
    },
    digifax: {
        add: '新增',
        DataDictionary: "数据目录字典",
        DataDictionary2: "数据字典",
        dataModelRequired: "请输入数模名称",
        orgIdName: "请选择归属企业",
        appList: "应用列表",
        dataModelName: "数模名称",
        desc: "概述",
        orgName: "归属机构",
        exportFile: "导出部署文件",
        syncApplyInfo: "同步至前置机",
        syncApplyInfoSuccess: "同步至前置机成功",
        dataQueryError: "数据查询失败，请重试！",
        configDataDic: "配置数据字典",
        classify: "分类",
        pleaseSelect: "请选择",
        addClassify: "添加分类",
        subcategory: "所属数据类别",
        dataList: "数据列表",
        variableName: "变量名称",
        cnName: "中文名称",
        addData: "新增数据",
        classifyName: "分类名称",
        dataCata: "数据目录",
        data: "数据",
        personal: "个人",
        unnecessary: "非必须",
        necessary: "必须",
        classifyRequired: "请输入分类名称",
        classifyValid: "分类名称只能包含汉字、字母、数字，不支持特殊符号！",
        getDataError: "获取数据失败",
        contentNoEmpty: "输入内容不能为空",
        variableValid: "变量名称只允许字母下划线组合，且开头不允许是下划线",
        nameDuplication: "存在重复，请重新编辑",
        deleteDataTip: "是否删除该条数据？",
        variableNameValid: "只允许字母下划线组合，且开头不允许是下划线",
        dataSaveSuccess: "数据保存成功",
        dataRequireError: "数据请求失败",
        digitalPublish: "数模发布",
        digitalIntroduction: "数模介绍",
        cancel: "取消",
        ok: "确定",
        required: "请填写数模介绍"

    },
    exRvidence: {
        orgIdRequired: "请选择归属机构",
        applyNameRequired: "请输入数模名称",
        bussinessNumRequired: "请输入业务编号",
        legalInfo: "存证信息",
        orgName: "机构名称",
        applyName: "数模名称",
        businessNum: "业务编号",
        look: "查看",
        legalDetail: "存证详情",
        desc: "概述",
        legalSource: "存证追溯",
        content: "内容",
        fileName: "文件名称",
        identityInputNum: "存证编号",
        identityInputTime: "存证时间"
    },
    givEvidence: {
        orgIdRequired: "请选择归属企业",
        outputFlagRequired: "请选择状态",
        applyNameRequired: "请输入应用名称",
        bussinessNumRequired: "请输入业务编号",
        legalInfo: "存证信息",
        orgName: "企业/部门名称",
        applyName: "应用名称",
        createdTime: "申请时间",
        status: "状态",
        applying: "申请中",
        pass: "已出证",
        applyRefuse: "出证失败",
        errorContent: "出证失败原因",
        all: "所有",
        bussinessNum: "业务编号"
    },
    dictionaries: {
        dict: '字典',
        dictPlaceholder: "请输入字典名称",
        english: '英文',
        englishPlaceholder: '请输入英文名称',
        type: '类型',
        typePlcaeholder: '请选择类型',
        dictRequired: "请输入字典名称",
        englishRequired: "请输入英文名称",
        typeRequired: "请输入类型名称",
        file: '文件',
        string: '字符串',
        editSuccess: "编辑成功",
        addSuccess: '新增成功',
        newCategory: '新增分类',
        catgoryName: '分类名称：',
        catgoryPlaceholder: '请输入分类名称'
    },
    upgradeManage: {
        AppManagement: "应用管理",
        PackageManagement: "程序包管理",
        rePush: '重推',
        pushing: '推送中',
        versionNumberError: '版本号输入格式有误',
        inService: "服务中",
        notDetected: "未检测",
        offline: "已下线",
        detectionFail: "检测失败",
        searchWay: "搜索条件",
        seriaNumPlaceholder: "请输入应用编号",
        applist: "应用列表",
        addApp: "添加应用",
        seriaNum: "应用编号",
        appName: "应用名称",
        status: "状态",
        createdTime: "创建时间",
        update: '更新',
        delete: '删除',
        online: '在线',
        Offline: "下线",
        view: "查看",
        appUpdate: "更新应用",
        appAdd: "添加应用",
        onlineSuccess: '上线成功',
        offlineSuccess: '下线成功',
        deleteConfirm: "此操作将永久删除该应用, 是否继续?",
        deleteSuccess: "删除成功",
        appDetail: '应用详情',
        pkgPlaceholder: "请输入包名称",
        pkgList: '程序包列表',
        viewRecord: '查看记录',
        pkgId: '包ID',
        pkgName: '包名称',
        script: '启动脚本',
        pkgDirectory: "程序包所在目录",
        createDate: "添加日期",
        push: '推送',
        createdVersion: "创建版本",
        viewVersion: '查看版本',
        versionNull: "版本为空，无法推送！",
        pushPkg: "推送程序包",
        updatePkg: "更新程序包",
        addPkg: "添加程序包",
        pushRecored: "推送记录",
        updateRecored: "更新记录",

        versionNumber: '版本号',
        PushingVersion: '推送版本',
        versionInfo: '版本信息',
        noversionInfo: "暂无版本信息!",
        deleteVersion: "此操作将永久删除该版本, 是否继续?"
    }
}



// WEBPACK FOOTER //
// ./src/views/admin/admin.zh-CN.js